export function isInShadow(node: HTMLElement) {
    for (; node; node = node.parentNode as HTMLElement) {
        if (node.toString() === "[object ShadowRoot]") {
            return true;
        }
    }
    return false;
}
